module.exports = __webpack_public_path__ + "img/586625a440d705e80b82a7227fda7241.586625a4.png";